import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchCropFields(agro_exporter_id, producer_id) {
    return RequesterV1.get(
      `agro_exporter/providers/producers/${agro_exporter_id}/fetch_crop_fields/${producer_id}`
    );
  },
  fetchCropField(agro_exporter_id, crop_field_id) {
    return RequesterV1.get(
      `agro_exporter/providers/producers/${agro_exporter_id}/fetch_crop_field/${crop_field_id}`
    );
  },
  fetchCrops(agro_exporter_id) {
    return RequesterV1.get(
      `agro_exporter/providers/producers/${agro_exporter_id}/fetch_crops`
    );
  },
  createCropField(agro_exporter_id, producer_id, crop_field) {
    return RequesterV1.post(
      `agro_exporter/providers/producers/${agro_exporter_id}/create_crop_field/${producer_id}`,
      { crop_field }
    );
  },
  updateCropField(agro_exporter_id, crop_field_id, crop_field) {
    return RequesterV1.post(
      `agro_exporter/providers/producers/${agro_exporter_id}/update_crop_field/${crop_field_id}`,
      { crop_field }
    );
  },
  destroyCropField(agro_exporter_id, crop_field_id) {
    return RequesterV1.delete(
      `agro_exporter/providers/producers/${agro_exporter_id}/destroy_crop_field/${crop_field_id}`
    );
  },
};
